import { useNavVisibility } from '@/hooks/use-nav-visibility'
import { cn } from '@/lib/utils'
import { useTabNotificationsStore } from '@/stores/tab-notifications.store'
import { Briefcase, FileText, GraduationCap, MessageCircle } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'

interface Tab {
  name: string
  href: string
  icon: typeof MessageCircle
  alwaysVisible: boolean
  notificationKey?: 'jobs' | 'skills'
}

const tabs: Tab[] = [
  { name: 'Coach', href: '/chat', icon: MessageCircle, alwaysVisible: true },
  { name: 'Resume', href: '/resume', icon: FileText, alwaysVisible: true },
  {
    name: 'Jobs',
    href: '/opportunities',
    icon: Briefcase,
    alwaysVisible: false,
    notificationKey: 'jobs',
  },
  {
    name: 'Learn',
    href: '/learn',
    icon: GraduationCap,
    alwaysVisible: false,
    notificationKey: 'skills',
  },
]

export function BottomNav() {
  const location = useLocation()
  const { hasResume } = useNavVisibility()
  const notifications = useTabNotificationsStore()

  const visibleTabs = tabs.filter((tab) => {
    if (tab.alwaysVisible) return true
    if (tab.href === '/opportunities') return hasResume
    if (tab.href === '/learn') return true
    return true
  })

  return (
    <nav className="border-t bg-background flex items-center justify-around h-14 shrink-0 pb-safe">
      {visibleTabs.map((tab) => {
        const Icon = tab.icon
        const isActive =
          location.pathname === tab.href || location.pathname.startsWith(`${tab.href}/`)
        const hasNotification = tab.notificationKey && notifications[tab.notificationKey]

        return (
          <Link
            key={tab.href}
            to={tab.href}
            onClick={() => {
              if (tab.notificationKey === 'jobs') {
                notifications.setJobsNotification(false)
              }
              if (tab.notificationKey === 'skills') {
                notifications.setSkillsNotification(false)
              }
            }}
            className={cn(
              'flex flex-col items-center justify-center gap-0.5 flex-1 h-full relative',
              isActive ? 'text-blue-600' : 'text-muted-foreground',
            )}
          >
            <div className="relative">
              <Icon className="h-5 w-5" />
              {hasNotification && (
                <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-blue-600 animate-pulse" />
              )}
            </div>
            <span className="text-[10px] font-medium">{tab.name}</span>
          </Link>
        )
      })}
    </nav>
  )
}
